import React from 'react';
import styles from './index.less';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import * as AHooks from 'ahooks';
import defaultNodeCover from '@/assets/default-node-cover.png';
import FPopoverPure from '@/components/FPopoverPure';
import fMessage from '@/components/fMessage';

// Figma：每组标签最多显示 3 个
const MAX_VISIBLE_LABELS = 3;

function Examples({}) {

  const [$nodes, set$nodes] = FUtil.Hook.useGetState<{
    nodeID: number;
    cover: string;
    title: string;
    labels: string[];
    about: string;
    href: string;
  }[]>([]);

  AHooks.useMount(async () => {

    const { ret, errCode, msg, data }: {
      ret: number;
      errCode: number;
      msg: string;
      data: {
        dataList: {
          nodeId: number;
          nodeDomain: string;
          nodeName: string;
          nodeTitle: string;
          nodeShortDescription: string;
          nodeLogo: string;
          tags: string[],
        }[];
      }
    } = await FServiceAPI.Node.searchForClient({
      nodeType: 1,
      limit: 100,
      // status: 0,
      // @ts-ignore
      nodeType: 1,
      // @ts-ignore
      sort: 'nodeTypeUpdateDate:-1',
    });
    if (ret !== 0 || errCode !== 0) {
      fMessage(msg, 'error');
      return;
    }

    set$nodes(data.dataList.map((dl) => {
      return {
        nodeID: dl.nodeId,
        cover: dl.nodeLogo || defaultNodeCover,
        title: dl.nodeTitle || dl.nodeName,
        labels: dl.tags,
        about: dl.nodeShortDescription,
        href: FUtil.Format.completeUrlByDomain(dl.nodeDomain),
      };
    }));
  });

  return (
    <div className={styles.root}>
      <div className={styles.tip}>
        Freelog为用户展示了一些场景示例，用户可以根据自己的需求选择主题或创建主题来搭建自己的节点
      </div>
      <div className={styles.nodes}>
        {$nodes.map((node) => {
          return (
            <NodeCard
              key={node.nodeID}
              nodeID={node.nodeID}
              cover={node.cover}
              title={node.title}
              labels={node.labels}
              about={node.about}
              href={node.href}
            />
          );
        })}
      </div>
    </div>
  );
}

export default Examples;

interface NodeCardProps {
  nodeID: number;
  cover: string;
  title: string;
  labels: string[];
  about: string;
  href: string;
}

function NodeCard({ nodeID, cover, title, labels, about, href }: NodeCardProps) {
  const visibleLabels = labels.slice(0, MAX_VISIBLE_LABELS);
  const hasMore = labels.length > MAX_VISIBLE_LABELS;

  return (<a
    className={styles.node}
    target={'_blank'}
    href={href}
    title={FI18n.i18nNext.t('discover_nodes_tooltips_view')}
  >
    <div className={styles.header}>
      <div
        className={styles.headerBg}
        style={{ backgroundImage: `url("${cover}")` }}
      />
      <div className={styles.headerMask}>
        <img className={styles.headerLogo} src={cover} alt={''} />
      </div>
    </div>
    <div className={styles.content}>
      <div className={styles.title} title={title}>
        {title}
      </div>
      {(visibleLabels.length > 0 || hasMore) && (
        <div className={styles.labels}>
          {visibleLabels.map((label, labelIndex) => {
            return (
              <div key={labelIndex} className={styles.label} title={label}>
                <span>{label}</span>
              </div>
            );
          })}
          {hasMore && (
            <FPopoverPure
              placement={'right'}
              content={
                <div
                  className={styles.PopoverLabels}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                >
                  {labels.map((l, i) => {
                    return (
                      <label key={i} title={l}>
                        <span>{l}</span>
                      </label>
                    );
                  })}
                </div>
              }
            >
              <div
                className={styles.more}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                ...
              </div>
            </FPopoverPure>
          )}
        </div>
      )}
      {about ? (
        <div className={styles.about} title={about}>
          {about}
        </div>
      ) : null}
    </div>
  </a>);
}
